import { FC } from "react";
import { Box } from "@mui/material";
import { v4 } from "uuid";

import { ITemplateData } from "@framework/types";

import { PieChart } from "./chart";
import { getSize } from "./utils";
import { useAlarmPaletteResolver } from "../../../../../../hooks/use-alarm-color";

export interface IPieDiagramProps {
  data: ITemplateData[];
  size?: string;
}

export const PieDiagram: FC<IPieDiagramProps> = props => {
  const { data, size } = props;
  const resolveAlarmColor = useAlarmPaletteResolver();

  const height = getSize(size);
  const width = getSize(size);

  const getLabel = (data: ITemplateData): string => {
    const { DiagramName, DiagramNum } = data;

    return DiagramName || DiagramNum || "";
  };

  const getLayer = (data: ITemplateData): string => {
    const { LayerName, LayerNum } = data;

    return LayerName ? ` ${LayerName}` : LayerNum ? ` ${LayerNum}` : "OneLayer";
  };

  const charts: any[] = [];

  const preparedDatasets = data.reduce((dataset: any[], current) => {
    const emptyDataset = {
      data: [],
      label: getLabel(current),
      layer: getLayer(current),
      alarmStatus: current.AlarmStatus,
      backgroundColor: [],
      hoverOffset: 4,
      borderColor: "#888888",
    };

    if (!dataset.length) {
      dataset.push(emptyDataset);
    }

    let foundDataset = dataset.find(({ label, layer }) => label === getLabel(current) && layer === getLayer(current));

    if (!foundDataset) {
      foundDataset = { ...emptyDataset };
      dataset.push(foundDataset);
    }

    foundDataset.data.push(current.Value);
    foundDataset.backgroundColor.push(
      current.AlarmStatus ? resolveAlarmColor(current.AlarmStatus) : current.BackgroundColor || "#FFFFFF",
    );

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return dataset;
  }, []);

  preparedDatasets.forEach(dataset => {
    const foundDataset = charts.find(chart => chart.find(({ label }: any) => dataset.label === label));

    if (!foundDataset) {
      charts.push([dataset]);
    } else {
      charts.forEach(chart => {
        const foundChart = chart.find(({ label }: any) => dataset.label === label);
        if (foundChart) {
          chart.push(dataset);
        }
      });
    }
  });

  return (
    <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", justifyContent: "center", mt: 4 }}>
      {charts.map(data => (
        <PieChart key={v4()} datasets={data} height={height} width={width} />
      ))}
    </Box>
  );
};
